// extracted by mini-css-extract-plugin
export default {"summary":"index_summary_KXl4k","cRed":"index_cRed_fMF9F"};